import { useNavigation } from '@react-navigation/native';
import moment from 'moment';
import React from 'react';
import { useTripInfoState } from 'src/common/hooks/states/useTripInfoState';
import { PrimaryButton, SuspenseFallback } from 'src/components';
import { DatePicker } from 'src/components/layout/DatePicker';
import { TripListHeaderTitle } from './components/TripListHeaderTItle';

const TripViewScreen = React.lazy(() => import('./TripListView'));

const TripListScreen = () => {
  const { searchInfo, changeDepartureDate } = useTripInfoState();
  const [isVisible, setVisible] = React.useState(false);
  const [date, setDate] = React.useState(searchInfo?.departureDate || new Date());
  const navigation = useNavigation();

  const handleChangeDatePress = () => setVisible(true);

  React.useLayoutEffect(() => {
    const headerTitle = () => {
      return (
        <TripListHeaderTitle
          origin={searchInfo?.fromLocation}
          destination={searchInfo?.toLocation}
          date={searchInfo?.departureDate}
          passenger={searchInfo?.passenger}
          onPress={handleChangeDatePress}
        />
      );
    };

    navigation.setOptions({
      headerTitle,
      // headerRight
    });
  }, [searchInfo?.departureDate]);

  const handleClose = () => {
    if (searchInfo?.departureDate) {
      setDate(searchInfo.departureDate);
    }
    setVisible(false);
  };

  const handleConfirm = () => {
    setVisible(false);
    changeDepartureDate(date);
  };

  return (
    <React.Suspense fallback={<SuspenseFallback />}>
      <TripViewScreen />
      <DatePicker
        value={date}
        onConfirm={setDate}
        isVisible={isVisible}
        onClose={handleClose}
        button={<PrimaryButton text="confirm" onPress={handleConfirm} />}
        disabledDates={calendarDate => {
          if (calendarDate.isBefore(moment().format('DD MMM, YYYY'))) return true;
          return false;
        }}
      />
    </React.Suspense>
  );
};

export default TripListScreen;
